<!--  -->

<template>
  <!-- :style="{height: viewerListHeight + 'px'}" -->
  <!-- <div></div> -->
  <ul class="viewer-container scrollbar" @click="closeHandle" @scroll="handleScroll" id="resultScroll"
    style="height: 100%">
    <li v-for="item in showUserList" :key="item.userId" class="viewer-content">
      <div class="viewer-left">
        <div class="viewer-avatar">
          <img :src="item.headImgUrl" width="30" class="icon_img" height="30" />
          <img :src="require('@/svg/pc_device.svg')" v-if="item.device == 1" />
          <img :src="require('@/svg/mobile_device.svg')" v-else />
        </div>
        <img :src="require('@/svg/silenced_icon.svg')" v-if="item.bannedToPost == true" class="viewer-silenced" />
        <div class="viewer-name">
          <h4>
            <span class="viewer-name-info" :data-tips="item.name">{{ item.name }}</span>
            <span v-if="hostUsersDuration">（{{ item.OnlineTime }}）</span>
          </h4>
        </div>
      </div>
      <div class="viewer-right" v-if="role == 3">
        <div class="pointer" @click.stop="showControlList(item)">
          <img class="more_icon" :src="require('@/svg/more.svg')" />
        </div>
      </div>
      <ul class="viewer-more-list" v-if="item.handle">
        <li class="pointer" v-if="item.bannedToPost == false" @click.stop="bannedToPostFunc(item)">
          {{ $t('viewer.禁言') }}
        </li>
        <li class="pointer" v-else @click.stop="bannedToPostFunc(item)">
          {{ $t('viewer.取消禁言') }}
        </li>
        <li class="pointer" @click.stop="delteUserChatMessage(item)">
          {{ $t('viewer.删除TA的聊天') }}
        </li>

        <li class="pointer">
          <el-popconfirm ref="popconfirm" :title="$t('viewer.你确定要踢出该用户吗')" icon="el-icon-info" placement="top"
            icon-color="#EA494B" @confirm="kickOutFunc(item)">
            <span slot="reference" @click.stop="">{{ $t('viewer.踢出') }}</span>
          </el-popconfirm>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
// getUserList
// getOnlineuUserList
import {
  getUserList,
  winkleUser,
  getUserTime,
} from "@/api/liveRequest/userApi";
import { uuid } from "@/utils/global";
import Bus from "@/components/doc/bus";
import { mapGetters } from "vuex";
import {
  pushRoomControlFunc,
  pushRoomMessageFunc,
  removeMessageFunc,
} from "@/utils/socketMessageDispose";

export default {
  props: {
    viewerListHeight: {
      type: Number,
    },
  },
  data() {
    return {
      userList: [], //观众列表
      searchName: null,
      oldSearchName: null,
      searchUserList: [],
      pageNo: 1,
      bannedToPostUserList: new Map(),
      showUserList: [],
      userNumber: null,
      listHeight: 0,
      getUserTimer: null,
    };
  },

  components: {},

  computed: {
    liveToken() {
      return this.$store.getters.liveToken;
    },
    liveId() {
      return this.$store.getters.liveId;
    },
    ccWebsocketClient() {
      return this.$store.getters.ccWebsocketClient;
    },
    chatRoomId() {
      return this.$store.getters.chatRoomId;
    },
    role() {
      //3:主播 2：助手 1：嘉宾
      return (
        this.$store.getters.selfParticipant &&
        this.$store.getters.selfParticipant.type
      );
    },
    liveConfig() {
      return this.$store.state.liveInfo.liveConfig;
    },
    userCount() {
      return this.$store.getters.userNumber;
    },
    ...mapGetters(["teamId", "hostUsersDuration", "liveRoomStatus"]),
  },
  watch: {
    liveToken(value) {
      if (value) {
        this.searchUserListFunc();
      }
    },
    teamId(value) {
      if (value) {
        this.userList = [];
        this.searchUserListFunc();
      }
    },
  },
  beforeDestroy() {
    Bus.$off("searchUserList");
    removeMessageFunc(this.getCvMcRoomMessage);
    removeMessageFunc(this.getCvMcRoomControl);
  },
  // watch: {
  //   showUserList() {
  //     return this.$emit(`changeUserNum`, this.showUserList.length);
  //   },
  // },
  created() {
    //收到聊天室消息
    pushRoomMessageFunc(this.getCvMcRoomMessage);
    pushRoomControlFunc(this.getCvMcRoomControl);
    if (this.liveToken) {
      this.searchUserListFunc();
    }
    this.init();
    window.addEventListener("resize", this.updateScrollHeight);
  },
  mounted() {
    this.updateScrollHeight();
  },
  methods: {
    updateScrollHeight() {
      const boxHeight = document.querySelector(
        ".chatAndUser-container"
      ).offsetHeight;
      this.listHeight = boxHeight - 48 - 66 - 60 + "px";
    },
    /**监听是否滚动到底部 */
    handleScroll() {
      var sh = document.getElementById("resultScroll").scrollHeight; // 滚动条高度
      var st = document.getElementById("resultScroll").scrollTop; // 滚动条距离顶部的距离
      var ch = document.getElementById("resultScroll").clientHeight; // 滚动条外容器的高度
      console.log("滚动加载");
      if (st + ch >= sh) {
        //到底了-业务逻辑
        console.log("handleScroll");
        this.pageNo++;
        this.searchUserListFunc();
      }
    },
    init() {
      let bannedToPostUserList = JSON.parse(
        sessionStorage.getItem("bannedUserList")
      );
      if (bannedToPostUserList) {
        for (let i = 0; i < bannedToPostUserList.length; i++) {
          const uid = bannedToPostUserList[i].uid,
            cid = bannedToPostUserList[i].cid;
          this.bannedToPostUserList.set(
            `${uid}_${cid}`,
            bannedToPostUserList[i]
          );
        }
      }
      Bus.$on("searchUserList", (searchName) => {
        if (searchName) {
          this.searchUserListFunc(50, searchName);
        } else {
          this.searchUserListFunc(200, searchName, 'all');
        }
      });
      Bus.$on("startUserTimer", () => {
        if (this.liveRoomStatus != 2) return
        if (this.hostUsersDuration) {
          for (let i = 0; i < this.showUserList.length; i++) {
            this.showUserList[i].onlineTimeSum =
              this.showUserList[i].onlineTimeSum + 1000;
            this.showUserList[i].OnlineTime = this.modifyUserTime(
              this.showUserList[i].onlineTimeSum
            );
          }
        }
      });
      Bus.$on("liveStart", () => {
        let userIds = null;
        for (let i = 0; i < this.showUserList.length; i++) {
          userIds = userIds
            ? `${userIds},${this.showUserList[i].userId}`
            : this.showUserList[i].userId;
        }
        this.getUserOnlineTimeSum(userIds);
      });
    },
    getCvMcRoomMessage(msg) {
      switch (msg.cmd) {
        case 7107: {
          this.disposeCustomMessage_7107(msg.requestData);
          break;
        }
        case 7127: {
          if (
            msg.requestData &&
            msg.requestData.event === "assistant_user_join_leave_state"
          ) {
            this.disposeCustomMessage_7107(msg.requestData);
          } else {
            this.disposeCustomMessage_7127(msg.requestData);
          }
          break;
        }
      }
    },
    getCvMcRoomControl(msg) {
      switch (msg.cmd) {
        case 6165: {
          let userData = msg.requestData.users;
          console.log(userData);
          for (let i = 0; i < msg.requestData.users.length; i++) {
            const uid = msg.requestData.users[i].uid,
              cid = msg.requestData.users[i].cid;
            this.bannedToPostUserList.set(
              `${uid}_${cid}`,
              msg.requestData.users[i]
            );
            const curSilenceUser = this.userList.find((u) => { return u.userId == uid })
            console.log(this.userList, 'curSilenceUser')
            if (curSilenceUser) {
              const status =
                msg.requestData.users[i].silence == 1
                  ? this.$t("chatroom.已被禁言")
                  : this.$t("chatroom.已被解除禁言");
              Bus.$emit("systemMsg", {
                name: curSilenceUser.name,
                text: status,
              });
              this.$message.success(`${curSilenceUser.name}${status}`);
            }
          }
          console.log(this.bannedToPostUserList, "观众端禁言列表");
          this.analysisChatJudgeBannedToPostUser();
          break;
        }
      }
    },
    /**处理7107消息内容体 */
    disposeCustomMessage_7107(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "user_state": {
            this.pageNo = 1;
            // var pageSize = 50;
            // if (this.userList.length > 50) {
            //   pageSize = this.userList.length;
            // }
            // this.searchUserListFunc(pageSize)
            break;
          }
          case "all_conf_user_name_modify": {
            const userId = requestData.uid;
            this.userList = this.userList.reduce((pre, cur) => {
              if (cur.userId == userId) {
                cur.name = requestData.nickName;
              }
              pre.push(cur);
              return pre;
            }, []);
            this.$store.commit('SET_AUDIENCE', this.userList);
            this.searchUserList = this.searchUserList.reduce((pre, cur) => {
              if (cur.userId == userId) {
                cur.name = requestData.nickName;
              }
              pre.push(cur);
              return pre;
            }, []);
            this.setShowUserList();
            break;
          }
          case "assistant_user_join_leave_state": {
            let userMsg =
              (requestData &&
                requestData.message &&
                JSON.parse(requestData.message)) ||
              requestData;
            if (userMsg.status == "join" && userMsg.role != 5) return;
            if (userMsg) {
              const userId = userMsg.userId;
              const curUserIndex = this.userList.findIndex((info) => {
                return info.userId == userId;
              });
              const curSearchIndex = this.searchUserList.findIndex((info) => {
                return info.userId == userId;
              });
              if (userMsg.status == "join") {
                if (curUserIndex != -1) {
                  this.userList.splice(curUserIndex, 1);
                } else {
                  this.userNumber++;
                  this.$emit(`changeUserNum`, this.userNumber);
                }
                if (curSearchIndex != -1) {
                  this.searchUserList.splice(curSearchIndex, 1);
                }
                this.setUserList(this.setOnlineUserValue(userMsg), "all");
                this.analysisChatJudgeBannedToPostUser();
              } else if (userMsg.status == "leave") {
                if (curUserIndex != -1) {
                  this.userList.splice(curUserIndex, 1);
                  this.userNumber--;
                  this.$emit(`changeUserNum`, this.userNumber);
                }
                if (curSearchIndex != -1) {
                  this.searchUserList.splice(curSearchIndex, 1);
                }
              } else if (userMsg.status == "remove") {
                if (curUserIndex != -1) {
                  this.userList.splice(curUserIndex, 1);
                  this.userNumber--;
                  this.$emit(`changeUserNum`, this.userNumber);
                }
                if (curSearchIndex != -1) {
                  this.searchUserList.splice(curSearchIndex, 1);
                }
              } else if (userMsg.status == "delete") {
                if (curUserIndex != -1) {
                  this.userList.splice(curUserIndex, 1);
                  this.userNumber--;
                  this.$emit(`changeUserNum`, this.userNumber);
                }
                if (curSearchIndex != -1) {
                  this.searchUserList.splice(curSearchIndex, 1);
                }
              } else if (userMsg.status == "update") {
                let curUser = this.userList.find((info) => {
                  return info.userId == userId;
                });
                let curUserIndex = this.userList.findIndex(
                  (val) => val.userId == userId
                );
                let searchUser = this.searchUserList.find((info) => {
                  return info.userId == userId;
                });
                let searchUserIndex = this.searchUserList.findIndex(
                  (val) => val.userId == userId
                );
                if (curUser) {
                  for (let key in curUser) {
                    if (key == "name" && userMsg.nickName) {
                      this.userList[curUserIndex][key] = userMsg.nickName;
                    }
                    if (userMsg[key]) {
                      curUser[key] = userMsg[key];
                    }
                  }
                }
                if (searchUser) {
                  for (let key in searchUser) {
                    if (key == "name" && userMsg.nickName) {
                      this.searchUserList[searchUserIndex][key] =
                        userMsg.nickName;
                    }
                    if (userMsg[key]) {
                      searchUser[key] = userMsg[key];
                    }
                  }
                }
              }
            }
            this.setShowUserList();
            break;
          }
          case "user_count_config_change":
            this.liveConfig.is_host_users_show = requestData.is_host_users_show;
            this.$store.commit("SET_LIVECONFIG", this.liveConfig);
            break;
        }
      }
    },
    disposeCustomMessage_7127(requestData) {
      if (requestData.event) {
        switch (requestData.event) {
          case "monitor_userList_change": {
            // this.pageNo = 1;
            // let pageSize = 50;
            // if (this.userList.length > 50) {
            //   pageSize = this.userList.length;
            // }
            // this.searchUserListFunc(pageSize)
            break;
          }
          case "assistant_user_online_user_count": {
            // const userInfo = requestData.groupCount.find((info) => {
            //   return info.groupId == this.teamId;
            // });
            // console.log(userInfo, "userInfo")
            // if (userInfo && userInfo.change == false) return;
            // if (userInfo && userInfo.userCount) {
            //   // if (userInfo.userCount <= this.userCount) {
            //     this.searchUserListFunc(200, null, "all");
            //   // } else {
            //   //   if (this.userList.length < 20) {
            //   //     if (new Date().getTime() - this.getUserTimer < 1000) {
            //   //       setTimeout(() => {
            //   //         this.searchUserListFunc();
            //   //       }, 1000);
            //   //     } else {
            //   //       this.getUserTimer = new Date().getTime();
            //   //       this.searchUserListFunc();
            //   //     }
            //   //   }
            //   // }
            //   this.$emit(`changeUserNum`, requestData.count);
            // }
            console.log(this.userCount, "this.userCount");
            //if(requestData.count !== this.userCount){
            this.searchUserListFunc(200, null, "all");
            // if(this.teamId !== '0'){
            //    const userInfo = requestData.groupCount.find((info) => {
            //     return info.groupId == this.teamId;
            //   });
            //   console.log(userInfo, "userInfo");
            //   console.log(requestData.count, "count");
            //   if (userInfo && userInfo.change == false) return;
            //   if (userInfo && userInfo.userCount) {
            //     //this.$emit(`changeUserNum`, userInfo.userCount);
            //   }
            // }else{
            this.$emit(`changeUserNum`, requestData.count);
            // }

            //}

            break;
          }
        }
      }
    },
    searchUserListFunc(pageSize, searchName, type) {
      let sortId;
      this.searchName = searchName;
      if (type == "all") {
        this.searchUserList = [];
        this.userList = [];
      } else {
        if (!this.searchName && this.userList.length != 0) {
          sortId = this.userList[this.userList.length - 1].sortId;
        } else if (
          this.searchName &&
          this.oldSearchName == this.searchName &&
          this.searchUserList.length != 0
        ) {
          sortId = this.searchUserList[this.searchUserList.length - 1].sortId;
        } else if (this.searchName && this.oldSearchName != this.searchName) {
          this.searchUserList = [];
        }
      }
      this.oldSearchName = this.searchName || searchName;
      // getUserList v2
      getUserList(
        {
          name: this.searchName,
          sortId,
          count: pageSize ? pageSize : 200,
          groupId: this.teamId != "0" ? this.teamId : "",
        },
        this.liveToken
      ).then((res) => {
        if (res && res.code == 200) {
          this.userNumber = res.data.count;
          this.$emit(`changeUserNum`, res.data.count);
          let userIds = null;
          res.data.userState.forEach((val) => {
            userIds = userIds ? `${userIds},${val.userId}` : val.userId;
            this.setUserList(this.setOnlineUserValue(val));
          });
          this.getUserOnlineTimeSum(userIds);
          this.setShowUserList();
          this.analysisChatJudgeBannedToPostUser();
          this.$store.commit('SET_AUDIENCE', res.data.userState);
        }
        // else {
        //   this.$message.error(`获取用户列表失败:${res.msg}`);
        // }
      });
    },
    setUserList(info, type) {
      if (!this.searchUserList.some((val) => val.userId === info.userId)) {
        if (this.searchName && type != "all") {
          let curIndex = this.searchUserList.findIndex((user) => {
            return user.sortId > info.sortId;
          });
          if (curIndex == -1) {
            // if (this.userNumber >= this.userList.length) {
            this.searchUserList.push(info);
            // }
          } else {
            this.searchUserList.splice(curIndex, 0, info);
          }
        }
      }
      if (!this.userList.some((val) => val.userId === info.userId)) {
        if (type == "all" || !this.searchName) {
          let curIndex = this.userList.findIndex((user) => {
            return user.sortId > info.sortId;
          });
          if (curIndex == -1) {
            if (this.userNumber >= this.userList.length) {
              this.userList.push(info);
            }
          } else {
            this.userList.splice(curIndex, 0, info);
          }
        }
      }

      // getUserTime(this.liveId,{userIds,webcastId:this.liveId}, this.liveToken).then(res=>{
      //   console.log(res)
      // })
    },
    getUserOnlineTimeSum(userIds) {
      if (!this.hostUsersDuration) return;
      getUserTime(
        this.liveId,
        { userIds, webcastId: this.liveId },
        this.liveToken
      ).then((res) => {
        if (res.code == 200 && res.data) {
          for (let i = 0; i < res.data.length; i++) {
            let findUser = this.showUserList.find((user) => {
              return user.userId == res.data[i].userId;
            });
            if (findUser) {
              findUser.onlineTimeSum = res.data[i].onlineTimeSum;
              findUser.OnlineTime = this.modifyUserTime(
                res.data[i].onlineTimeSum
              );
            }
          }
        }
      });
    },
    modifyUserTime(onlineTimeSum) {
      let minutes = onlineTimeSum ? parseInt(onlineTimeSum / 1000 / 60) : 0;
      let second = onlineTimeSum ? parseInt((onlineTimeSum / 1000) % 60) : 0;
      return minutes + this.$t('viewer.分') + second + this.$t('viewer.秒');
    },
    /*设置在线列表值 */
    setOnlineUserValue(val) {
      console.log(val, "在线列表info");
      let onlineUser = {
        name: val.nickName,
        // title: this.$userRoleEnum[val.role],
        role: val.role,
        roomUid: val.roomUid,
        roomDev: val.roomDev,
        sortId: val.sortId,
        cid: val.cid,
        chatRoomId: val.chatRoomId,
        markId: val.markId,
        userId: val.userId,
        markType: val.markType,
        // img: `${process.env.VUE_APP_LAYOUT_API}/public/avatar.svg`,
        handle: false,
        bannedToPost: false,
        headImgUrl: val.headImgUrl || require("@/svg/viewer_avatar.svg"),
        device: val.device,
        OnlineTime: 0,
        onlineTimeSum: 0,
      };
      return onlineUser;
    },
    closeHandle() {
      let curOpenList = this.showUserList.find((info) => {
        return info.handle;
      });
      if (curOpenList) {
        curOpenList.handle = false;
      }
    },
    showControlList(item) {
      this.closeHandle();
      item.handle = true;
    },
    /** 生成一个通信32位id */
    getChatHeadId() {
      return `${uuid(15, 62)}${new Date().getTime()}`;
    },
    // 删除聊天
    delteUserChatMessage(item) {
      let head = {
        cmd: 1715,
        id: this.getChatHeadId(),
        room_id: this.chatRoomId,
      };
      console.log(item);
      let Body = {
        msgs: [
          {
            from_cid: item.cid,
            from_uid: item.roomUid,
            from_dev: item.roomDev,
          },
        ],
        all: 1,
      };
      this.ccWebsocketClient.customizeSendMsg(head, Body);
      item.handle = false;
      this.$message.success(this.$t('viewer.操作成功'));
    },
    // 踢出
    kickOutFunc(item) {
      winkleUser(
        { webcastId: this.liveId, userId: item.userId },
        this.liveToken
      )
        .then((res) => {
          // this.$message.info(`${res.msg}`);
          if (res.code === 200) {
            this.pageNo = 1;
          }
          this.logger.info({ code: 2019, message: this.$store.getters.selfParticipant })
        })
        .catch((err) => {
          this.logger.error({ code: 2020, message: err })
        });
    },
    bannedToPostFunc(item) {
      this.ccWebsocketClient.setCvMcRoomUserAttr(
        this.chatRoomId,
        [
          {
            cid: item.cid,
            uid: item.userId,
            dev: item.roomDev,
            silence: item.bannedToPost ? 0 : 1,
          },
        ],
        "cloud_webcast"
      );
      item.handle = false;
    },
    analysisChatJudgeBannedToPostUser() {
      this.setShowUserList();
      let bannedToPostUserList = Array.from(this.bannedToPostUserList.values());
      if (this.showUserList.length == 0 || bannedToPostUserList.length == 0)
        return;
      for (let i = 0; i < bannedToPostUserList.length; i++) {
        let uid = bannedToPostUserList[i].uid;
        for (let j = 0; j < this.showUserList.length; j++) {
          if (this.showUserList[j].userId == uid) {
            this.showUserList[j].bannedToPost =
              bannedToPostUserList[i].silence == 1 ? true : false;
          }
        }
      }
      // this.setShowUserList();
    },
    setShowUserList() {
      this.showUserList = this.searchName
        ? this.searchUserList
        : this.userList
      console.log(this.showUserList, "this.showUserList 显示列表");
    },
  },
};
</script>
<style lang="scss" scoped>
.viewer-container {
  overflow-y: auto;

  .viewer-content {
    padding-left: 5px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    .viewer-left {
      color: $white-color;

      h4 {
        .viewer-name-info {
          max-width: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          display: inline-block;
        }
        .viewer-name-info:hover:after {
          content: attr(data-tips); /* 显示提示文本 */
          background: rgba(0, 0, 0, 0.8); /* 背景透明 */
          color: #fff;
          position: absolute;
          top: 50%; /* 位于文本下方 */
          left: 40px;
          max-width: 200px; /* 最大宽度为200px */
          white-space: normal;
          padding: 10px;
          border-radius: 3px;
          z-index: 1;
          display: none;
        }

        .viewer-name-info:hover:after {
          display: block; /* 显示提示文本 */
        }

        span {
          display: inline-block;
          vertical-align: middle;
        }
      }

      .viewer-avatar,
      .viewer-name {
        display: inline-block;
        line-height: 30px;
        vertical-align: middle;
        overflow: hidden;
        text-align: left;

        img {
          vertical-align: middle;
          margin-left: 5px;
        }

        .icon_img {
          border-radius: 15px;
        }

        img:last-child {
          // filter: drop-shadow($grey5-color 80px 0);
          // -webkit-filter: drop-shadow($grey5-color 80px 0);
          // transform: translateX(-80px);
          margin: 0px 10px;
        }
      }

      .viewer-silenced {
        position: absolute;
        bottom: 10px;
        left: 30px;
      }
    }

    .viewer-right {
      >div {
        display: inline-block;
        margin-right: 10px;
        overflow: hidden;
        width: 20px;

        img {
          // filter: drop-shadow($grey5-color 80px 0);
          // -webkit-filter: drop-shadow($grey5-color 80px 0);
          // transform: translateX(-80px);
        }
      }
    }

    .viewer-more-list {
      right: 10px;
      position: absolute;
      background-color: #2d3052;
      width: 110px;
      border-radius: 4px;
      z-index: 999;
      top: 35px;
      padding: 10px 0px;

      li {
        height: 32px;
        line-height: 32px;
        color: #fff;
        padding: 0 12px;
        text-align: left;
      }
    }
  }
}
</style>
